import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const sections = [
  {
    title: '1. Information Collection',
    items: [
      {
        heading: 'Personal Information',
        text: 'Nura collects personal details like name, email, phone number, address, payment information, and location data when users register, use services, or contact support.',
      },
      {
        heading: 'Usage Data',
        text: 'Information about how users interact with the app, including IP address, device information, browser type, and pages visited.',
      },
      {
        heading: 'Cookies & Tracking',
        text: 'Uses cookies and similar technologies to track activity and enhance user experience.',
      },
    ],
  },
  {
    title: '2. Use of Information',
    bullets: [
      'To provide, maintain, and improve services (e.g., ride booking, customer support).',
      'To process transactions and send related information.',
      'To personalize user experience and deliver targeted advertising.',
      'For security purposes, fraud prevention, and legal compliance.',
      'For research and analytics to understand usage patterns.',
    ],
  },
  {
    title: '3. Information Sharing',
    items: [
      {
        heading: 'Service Providers',
        text: "Shares data with third-party vendors who perform services on Nura's behalf (e.g., payment processing, analytics).",
      },
      {
        heading: 'Business Transfers',
        text: 'May share data in connection with a merger, acquisition, or asset sale.',
      },
      {
        heading: 'Legal Requirements',
        text: "Discloses information if required by law or to protect Nura's rights, property, or safety.",
      },
      {
        heading: 'Consent',
        text: 'Shares information with user consent.',
      },
    ],
  },
  {
    title: '4. Data Security',
    text: 'Nura implements reasonable security measures to protect personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is 100% secure.',
  },
  {
    title: '5. User Rights',
    bullets: [
      'Users have rights to access, correct, update, or delete their personal information.',
      'They can object to processing, request data portability, and withdraw consent.',
      'Users can opt-out of marketing communications.',
    ],
  },
  {
    title: '6. Third-Party Links',
    text: "The app may contain links to third-party websites; Nura is not responsible for their privacy practices.",
  },
  {
    title: "7. Children's Privacy",
    text: "Nura's services are not directed at individuals under 13, and it does not knowingly collect personal information from children.",
  },
  {
    title: '8. Changes to Privacy Policy',
    text: 'Nura reserves the right to update the policy and will notify users of significant changes.',
  },
  {
    title: '9. Contact Information',
    text: 'For privacy-related questions or concerns, please contact us at info@nuraemobility.co.in or call +91 9566053118.',
  },
];

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
        <p className="text-gray-500 text-sm mb-10">Last updated: March 2025</p>

        <p className="text-gray-700 mb-10 leading-relaxed">
          At Nura, we are committed to protecting your privacy. This Privacy Policy explains how we collect,
          use, and safeguard your information when you use our services.
        </p>

        <div className="space-y-10">
          {sections.map((section, i) => (
            <div key={i}>
              <h2 className="text-xl font-bold text-gray-900 mb-3">{section.title}</h2>

              {/* Plain text */}
              {section.text && (
                <p className="text-gray-700 leading-relaxed">{section.text}</p>
              )}

              {/* Bullet list */}
              {section.bullets && (
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  {section.bullets.map((b, j) => (
                    <li key={j} className="leading-relaxed">{b}</li>
                  ))}
                </ul>
              )}

              {/* Sub-items with headings */}
              {section.items && (
                <ul className="space-y-3">
                  {section.items.map((item, j) => (
                    <li key={j} className="text-gray-700 leading-relaxed">
                      <span className="font-semibold text-gray-900">{item.heading}: </span>
                      {item.text}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
